'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'chevrons-up';
var width = 512;
var height = 512;
var aliases = ["chevron-double-up"];
var unicode = 'f325';
var svgPathData = 'M278.9 41.4l-22.6-22.6-22.6 22.6-192 192-22.6 22.6 45.3 45.3 22.6-22.6 169.4-169.4 169.4 169.4 22.6 22.6 45.3-45.3-22.6-22.6-192-192zm0 192l-22.6-22.6-22.6 22.6-192 192-22.6 22.6 45.3 45.3 22.6-22.6 169.4-169.4 169.4 169.4 22.6 22.6 45.3-45.3-214.6-214.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;